// extracted by mini-css-extract-plugin
export var buttonContent = "_3z-0";
export var centered = "_3z-1";
export var centeredFlex = "_3z-2";
export var errorText = "_3z-3";
export var icon = "_3z-4";
export var iconButtonContent = "_3z-5";
export var monospace = "_3z-6";
export var padded = "_3z-7";